import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IGroup } from '@models/general/group';
import { ILocation, ILocationPhoto } from '@models/restore-id/location';


@Injectable()
export class LocationService {
  private _url = 'api/location';
  private _urlLocationPhoto = 'api/location-photo';
  private _urlPhoto = 'api/photo';

  constructor(private _httpClient: HttpClient) { }

  async getLocations(): Promise<ILocation[]> {
    return new Promise((resolve, reject) => {
      this._httpClient.get<ILocation[]>(`${this._url}`).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err)
        }
      });
    });
  }

  async getLocationsByGroupId(groupid: string): Promise<ILocation[]> {
    return new Promise((resolve, reject) => {

      this._httpClient.get<ILocation[]>(`${this._url}/get-by-groupid/${groupid}`).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err)
        }
      });
    });
  }

  async getLocationGroup(name: string): Promise<IGroup> {
    return new Promise((resolve, reject) => {
      this._httpClient.get<IGroup[]>(`${this._url}/get-group/${name}`).subscribe({
        next(value) {
          if (Array.isArray(value) && value.length > 0) {
            resolve(value[0]); // Resolve with the first group in the array
          } else {
            reject(new Error('No group found'));
          }
        },
        error(err) {
          reject(err)
        }
      });
    });
  }

  async getLocationById(id: string): Promise<ILocation> {
    return new Promise((resolve, reject) => {

      this._httpClient.get<ILocation>(`${this._url}/${id}`).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err)
        }
      });
    });
  }

  async getLocationByName(name: string): Promise<ILocation> {
    return new Promise((resolve, reject) => {
      this._httpClient.get<ILocation>(`${this._url}/get-by-name/${name}`).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err)
        }
      });
    });
  }

  async checkLocationExist(name: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this._httpClient.get<boolean>(`${this._url}/exist/${name}`).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err)
        }
      });
    });
  }

  async createNewLocation(location: ILocation): Promise<void> {
    return new Promise((resolve, reject) => {
      this._httpClient.post<void>(`${this._url}`, location).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err)
        }
      });
    });
  }

  async importLocation(data: ILocation[]): Promise<void> {
    return new Promise((resolve, reject) => {
      this._httpClient.post<void>(`${this._url}/import`, { data }).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err)
        }
      });
    });
  }

  async updateLocation(id: string, updatedData: ILocation): Promise<void> {
    return new Promise((resolve, reject) => {
      this._httpClient.put<void>(`${this._url}/${id}`, updatedData).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err);
        }
      });
    });
  }

  async deleteLocation(id: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this._httpClient.delete<void>(`${this._url}/${id}`).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err);
        }
      });
    });
  }

  // -------------------- Photo --------------------

  async getLocationPhotos(locationname: string): Promise<ILocationPhoto[]> {
    const encodedLocationname = encodeURIComponent(locationname);
    return new Promise((resolve, reject) => {
      this._httpClient.get<ILocationPhoto[]>(`${this._urlLocationPhoto}/${encodedLocationname}`).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err);
        }
      });
    });
  }

  async getTrapPhotos(locationname: string, trapname: string): Promise<ILocationPhoto[]> {
    const encodedLocationname = encodeURIComponent(locationname);
    const encodedTrapname = encodeURIComponent(trapname);
    return new Promise((resolve, reject) => {
      this._httpClient.get<ILocationPhoto[]>(`${this._urlLocationPhoto}/${encodedLocationname}/${encodedTrapname}`).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err);
        }
      });
    });
  }

  async fetchPhoto(photoid: string): Promise<Blob> {
    return new Promise((resolve, reject) => {
      this._httpClient.get(`${this._urlPhoto}/${photoid}`, { responseType: 'blob' }).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err);
        }
      });
    });
  }

}
